export default "__VITE_ASSET__DMczpGdr__"